export default __webpack_public_path__ + "static/media/bannerImage3.38c107ac.png";